import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { CALENDAR_SETTINGS_ROUTES } from "../../modules/constants";

export default () => ({
  path: CALENDAR_SETTINGS_ROUTES.EVENTS,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "calendar-settings-events" */ "./components"
    ).then(m => m.default)
  ),
});
